import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import { observer } from "mobx-react";
import { memo } from "react";
import style from "./style.module.scss";
const { Panel } = Collapse;

interface Props {}
const DataSecurityAssurance: React.FC<Props> = observer(({ ...props }) => {
  const onChange = (key: string | string[]) => {};
  return (
    <div className={style.mainWrraper}>
      <h1 style={{ textAlign: "center" }}>Data Security Assurance</h1>
      <p style={{ textAlign: "center", fontSize: "16px" }}>
        Updated: May 26, 2025
      </p>
      <p style={{ textAlign: "center", fontSize: "16px" }}>
        Thank you for using Climate Finance Co-pilot
      </p>
      <p
        style={{
          lineHeight: "26px",
          width: "50%",
          margin: "auto",
          marginBottom: 20,
          fontSize: "16px",
        }}
      >
        This Data Security Assurance and Non-Disclosure Agreement ("Agreement")
        outlines the terms under which Janus Advisory Services Inc.
        ("Recipient") agrees to receive and protect the confidential information
        of users ("Discloser") who use the Climate Finance Copilot platform. By
        using our services, you agree to these terms. This Agreement is integral
        to maintaining the confidentiality, integrity, and security of all data
        provided.
      </p>
      <div className={style.collapseWrraper}>
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? (
              <div className={style.plusIcon}>
                <MinusOutlined />
              </div>
            ) : (
              <div className={style.plusIcon}>
                <PlusOutlined />
              </div>
            )
          }
          defaultActiveKey={["1"]}
          onChange={onChange}
        >
          <Panel header="1. Definition of Confidential Information" key="1">
            <p>
              Confidential Information includes all non-public data, documents,
              and communications disclosed by the user, including but not
              limited to project proposals, financial models, and environmental
              assessments uploaded to the platform.
            </p>
          </Panel>
          <Panel header="2. Obligations of Recipient" key="2">
            <p>
              Recipient agrees to use Confidential Information only for
              supporting the user, restrict access to authorized personnel,
              implement strong security safeguards, and never use the data to
              train general AI models without explicit opt-in consent.
            </p>
          </Panel>
          <Panel header="3. Exclusions from Confidential Information" key="3">
            <p>
              This Agreement does not apply to information that becomes public,
              was previously known to Recipient, is disclosed by a third party
              legally, or is independently developed.
            </p>
          </Panel>
          <Panel header="4. Compelled Disclosure" key="4">
            <p>
              If required by law to disclose data, Recipient will notify the
              Discloser, cooperate in seeking legal protection, and only
              disclose the minimum necessary.
            </p>
          </Panel>
          <Panel header="5. Term and Duration of Confidentiality" key="5">
            <p>
              This Agreement remains effective as long as the user maintains an
              account. Confidentiality obligations survive termination for five
              years or longer for trade secrets.
            </p>
          </Panel>
          <Panel
            header="6. Return or Destruction of Confidential Information"
            key="6"
          >
            <p>
              Upon request or account termination, Recipient will return or
              securely destroy all Confidential Information and provide
              certification of destruction if required.
            </p>
          </Panel>
          <Panel header="7. No License or Warranty" key="7">
            <p>
              Discloser retains ownership of all Confidential Information. No
              licenses or warranties are granted beyond those explicitly stated.
            </p>
          </Panel>
          <Panel header="8. Intellectual Property" key="8">
            <p>
              All rights, including intellectual property, in Confidential
              Information remain with the Discloser. Recipient receives only a
              limited right to use such information.
            </p>
          </Panel>
          <Panel header="9. Remedies" key="9">
            <p>
              Unauthorized use or disclosure may cause irreparable harm. The
              Discloser is entitled to seek injunctive or equitable relief.
            </p>
          </Panel>
          <Panel header="10. Governing Law and Jurisdiction" key="10">
            <p>
              This Agreement is governed by the laws of Florida, USA. Legal
              disputes shall be resolved in Florida courts.
            </p>
          </Panel>
          <Panel header="11. Miscellaneous Provisions" key="11">
            <p>
              This Agreement constitutes the entire agreement and may be
              modified with notice. Severability, waiver, and assignment clauses
              apply.
            </p>
          </Panel>
          <Panel header="12. Acceptance of Agreement" key="12">
            <p>
              By clicking "I Agree" or uploading content, you consent to this
              Agreement. If you are acting on behalf of an entity, you confirm
              your authority to bind them.
            </p>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
});

export default memo(DataSecurityAssurance);
